<svg [ngClass]="'icon-avatar avatar-' + id"
     [attr.data-automation-id]="'bc-avatar'">
  <use [attr.xlink:href]="'#bc-avatar-' + id" xlink:href=""></use>
</svg>
